'use client'

import { useOrganization } from '@clerk/nextjs'
import { PricingCards } from '@/components/pricing/pricing-cards'
import SuccessPopup from '@/components/success-popup'
import { GeniiusUser } from '@/lib/types'

interface PricingPageClientProps {
  userId: string | null
  orgId: string | null
  user: GeniiusUser | null
  organization: any
}

export function PricingPageClient({ userId, orgId, user, organization }: PricingPageClientProps) {
  const { membership, organization: clerkOrganization } = useOrganization()
  const isAdmin = membership?.role === 'org:admin'

  return (
    <div className="flex-1 flex flex-col items-center justify-center py-24">
      <div className="container px-4">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-semibold mb-4">Choose your plan</h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            Get started with mixus today
          </p>
        </div>
        
        <PricingCards 
          showCheckout={!!userId} 
          user={user} 
          organization={organization && clerkOrganization ? {
            ...organization,
            membersCount: clerkOrganization.membersCount
          } : organization}
          isLanding={!userId}
          orgId={orgId}
          isAdmin={isAdmin}
        />
      </div>
      {userId && <SuccessPopup />}
    </div>
  )
} 